import {forwardRef} from 'react'
import {Input, type InputProps} from '@/components/ui/input'
import {cn} from '@/lib/utils'

type MonoInputSize = 'xs' | 'sm' | 'default'

interface MonoInputProps extends Omit<InputProps, 'size'> {
    inputSize?: MonoInputSize
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses: Record<MonoInputSize, string> = {
    xs: 'h-7 text-xs',
    sm: 'h-8 text-sm',
    default: '',
}
/* eslint-enable i18next/no-literal-string */

/**
 * Monospace-styled text input. Use for cron expressions, script fragments, or
 * any value that benefits from a fixed-width font.
 */
export const MonoInput = forwardRef<HTMLInputElement, MonoInputProps>(function MonoInput(
    {inputSize = 'default', className, ...props},
    ref,
) {
    return (
        <Input
            ref={ref}
            className={cn('font-mono', sizeClasses[inputSize], className)}
            {...props}
        />
    )
})
